module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "Preface-1"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anguage To Live In")]), _vm._v(" is my fourth book of poems (preceded by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Simple Rules")]), _vm._v(" 1991, 2007; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Erotic Reckonings ")]), _vm._v("2012; and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pied-Piper Philology: Love Words ")]), _vm._v("2013). Of the many poems I have written, as well as published, the constant theme is the power—and its obverse, powerlessness—of language. Like any writer born in, and emerging from, the 20th century, I am constantly reminded of the powerlessness of language, a practically obsessional theme of poets in the European and American traditions during that century of holocausts. But, I also feel and celebrate in my poems the power of language, and I give equal emphasis to both, or at least I try to do so. My one aspiration in all my poems is to use adequate language adequately: language adequate to the imperatives of imagination, used with skill adequate to the demands of form. If readers should feel that I have succeeded even once or twice in fulfilling this aspiration, then the lifetime of writing I have lived will have been worth the effort—‘To Him of adequate desire / No further ’tis, than here’ (Emily Dickinson "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("370")]), _vm._v(").")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec661b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781645367314_EPUB-6.vue
// module id = 75
// module chunks = 0